import { useEffect, useState } from "react";
// utils/membershipUtils.js

export const getMembershipStatus = (expiresDateMembership) => {
  if (!expiresDateMembership) return null;

  const now = new Date();
  const expirationDate = new Date(expiresDateMembership);

  // Resetear horas para comparar solo fechas
  const today = new Date(now.setHours(0, 0, 0, 0));
  const expDate = new Date(expirationDate.setHours(0, 0, 0, 0));

  // Calcular diferencia en milisegundos
  const diffTime = expDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return {
      isExpired: false,
      isAboutToExpire: false,
      expiresToday: true,
      daysRemaining: 0,
    };
  } else if (diffDays < 0) {
    return {
      isExpired: true,
      isAboutToExpire: false,
      expiresToday: false,
      daysRemaining: diffDays,
    };
  } else if (diffDays <= 3) {
    return {
      isExpired: false,
      isAboutToExpire: true,
      expiresToday: false,
      daysRemaining: diffDays,
    };
  } else {
    return {
      isExpired: false,
      isAboutToExpire: false,
      expiresToday: false,
      daysRemaining: diffDays,
    };
  }
};

const useMembershipExpiration = (expiresDateMembership) => {
  const [membershipStatus, setMembershipStatus] = useState({
    isExpired: false,
    isAboutToExpire: false,
    expiresToday: false,
    daysRemaining: null,
  });

  const checkExpiration = () => {
    const status = getMembershipStatus(expiresDateMembership);
    if (status) {
      setMembershipStatus(status);
    }
  };

  useEffect(() => {
    if (!expiresDateMembership) return;

    checkExpiration();
    const intervalId = setInterval(checkExpiration, 24 * 60 * 60 * 1000); // cada 24h
    return () => clearInterval(intervalId);
  }, [expiresDateMembership]);

  return membershipStatus;
};

export default useMembershipExpiration;
